import React from "react"
import PropTypes from "prop-types"
import BtnPrimary from '../../form_sections/BtnPrimary';

class NoMatchesLocation extends React.Component {

  constructor(props) {
    super(props)

    this.updateFilter = this.updateFilter.bind(this)
  }

  updateFilter() {
    this.props.updateFilter()
  }

  render() {
    return(
      <div style={{textAlign: 'center', margin: 'auto', maxWidth: 400, padding: 10}}>
        <h2 className="darkBlue" style={{marginBottom: 15}}>No matches in your location!</h2>
        <h3 className="darkBlue" style={{fontWeight: 200}}>Let’s find matches outside of your city - expand the search to see more Lex connections.</h3>
        <img
          style={{marginTop: 50, marginBottom: 50}}
          src={this.props.noMatchLocationIcon}
          alt="No matches in your location" />
        <BtnPrimary
          onClick={() => this.updateFilter()}
          buttonText="Search around the world"
        />
      </div>
    )
  }


}

export default NoMatchesLocation
